import styled, { keyframes } from 'styled-components/macro';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.gray900};
  height: 100vh;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;

export const Content = styled.main`
  margin-top: 60px;
  flex: 1;
  height: calc(100vh - 181px);
  overflow: auto;
`;

export const CarList = styled.div`
  scroll-margin-top: 330px;
  //overflow-y: auto;
  max-height: calc(100vh - 216px);
  padding: 16px;

  '&.car-list-with-error' : {
    max-height: calc(100vh - 172px);
    padding-top: 23px;
  }
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
    height: 0;
    padding: 0;
    margin-bottom: 0;
  }
  25% {
    opacity: .25;
    height: 25%;
    padding: 4px;
    margin-bottom: 3px;
  }
  50% {
    opacity: .5;
    height: 50%;
    padding: 8px;
    margin-bottom: 6px;
  }
  75% {
    opacity: .75;
    height: 75%;
    padding: 12px;
    margin-bottom: 9px;
  }
  100% {
    opacity: 1;
    height: 100%;
    padding: 16px;
    margin-bottom: 12px;
  }

`;

const fadeOut = keyframes`
  100% {
    opacity: 0;
    height: 0;
    padding: 0;
    margin-bottom: 0;
  }
  75% {
    opacity: .25;
    height: 25%;
    padding: 4px;
    margin-bottom: 3px;
  }
  50% {
    opacity: .5;
    height: 50%;
    padding: 8px;
    margin-bottom: 6px;
  }
  25% {
    opacity: .75;
    height: 75%;
    padding: 12px;
    margin-bottom: 9px;
  }
  0% {
    display: flex;
    opacity: 1;
    height: 100%;
    padding: 16px;
    margin-bottom: 12px;
  }
`;

export const FieldRow = styled.div<{ $isHide?: boolean | null }>`
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.gray800};
  border-radius: 8px;
  animation: ${({ $isHide }) => ($isHide ? fadeOut : fadeIn)} 0.2s;
  opacity: ${({ $isHide }) => ($isHide ? 0 : 1)};
  height: ${({ $isHide }) => ($isHide ? 0 : '100%')};
  padding: ${({ $isHide }) => ($isHide ? 0 : '16px')};
  margin-bottom: ${({ $isHide }) => ($isHide ? 0 : '12px')};
`;

export const Title = styled.p`
  color: ${({ theme }) => theme.colors.green500};
  font-size: 16px;
`;

export const QuestionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 16px;
`;
export const DropdownWrapper = styled.div`
  display: flex;
  width: 100%;
  & > div {
    width: 100%;
  }
`;
export const CityWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
  width: 100%;
`;
export const MapButton = styled.div`
  display: flex;
  margin-top: 10px;
  width: 100%;
`;
export const MileageWrapper = styled.div``;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  padding: 0 8px 8px 0;
`;

export const Checkbox = styled.input`
  accent-color: ${({ theme }) => theme.colors.green500};
  clip-path: circle(60% at 50% 50%);
  border-radius: 50%;
  margin-inline-end: 12px;
  width: 20px;
  height: 20px;
`;

export const CheckboxTitle = styled.p`
  color: ${({ theme }) => theme.colors.gray0};
  font-size: 14px;
`;

export const RadioTitle = styled.p`
  color: ${({ theme }) => theme.colors.gray0};
  font-size: 14px;
  margin-inline-start: 12px;
`;

export const SelectDatePicker = styled.p`
  width: 100%;
`;

export const InputWrapper = styled.div`
  width: 100%;
  margin-bottom: 12px;
`;

export const OptionBox = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 0;
  border: none;
  margin-bottom: 16px;
  position: relative;

  & > span {
    align-self: flex-start;
    font-size: 20px;
  }

  label {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: ${({ theme }) => theme.colors.gray0};
  }
`;

export const CheckBox = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: flex-end;
  align-self: start;
  gap: 8px;
  padding: 0;
  border: none;
  margin-bottom: 16px;
  position: relative;
  cursor: pointer;

  :before {
    content: '';
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 4px;
    background-color: ${({ theme, isSelected }) =>
      isSelected ? theme.colors.green500 : 'transparent'};
    border: 1px solid ${({ theme, isSelected }) => (isSelected ? theme.colors.green500 : 'white')};
  }

  span {
    font-size: 12px;
    position: absolute;
    left: 1px;
    top: 3px;
  }
`;

export const CheckLabel = styled.label`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.gray0};
  cursor: pointer;
`;

export const ErrorBodyWrapper = styled.div`
  padding-top: 12px;

  & > p {
    color: ${({ theme }) => theme.colors.gray0};
  }
`;

export const ErrorButtons = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
  gap: 16px;
`;

export const StatusBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 24px;
  background-color: ${({ theme }) => theme.colors.gray800};
`;

export const StatusLabel = styled.label`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.gray0};
`;
